import * as React from 'react';
import classNames from 'classnames';

type Props = {
    className?: string;
};

const TrustBoxWidget = (props: Props) => {
    const { className } = props;

    return (
        <div
            className={classNames('trustpilot-widget', className)}
            data-businessunit-id="568eb2e10000ff00058751ce"
            data-locale="en-US"
            data-style-height="52px"
            data-style-width="270px"
            data-template-id="5419b732fbfb950b10de65e5"
            data-theme="light"
        >
            <a href="https://www.trustpilot.com/review/liveauctioneers.com" rel="noopener" target="_blank">
                Trustpilot
            </a>
        </div>
    );
};

export default TrustBoxWidget;
